module.exports = __webpack_public_path__ + "static/Tavel-5e86a5c8c4f48b188ab423b0ee93abb5.mp4";